import React from 'react'
import Section from './Section'

export default ({ calculateViewChange, prospect, prospectPatched }) => {
  const loaded = !!prospectPatched
  if (loaded) prospect = prospectPatched
  const rv = prospect && prospect.replacementVehicle && prospect.replacementVehicle.find(q => q.questionId === 'qrv/LeadType')
  const year = prospect && prospect.replacementVehicle.find(q => q.questionId === 'qrv/YearRange')
  const makemodel = prospect && prospect.replacementVehicle.find(q => q.questionId === 'qrv/MakeAndModel')
  const lookingFor = prospect && prospect.replacementVehicle.find(q => q.questionId === 'qrv/LookingFor')
  let uniqueViewStr = 'uniqueViewStr:' + (rv && rv.value)
  const component = (
    <>
      {rv && rv.value === 'OptIn' ? (
        <Section title={'Replacement Vehicle'} showEdit={false}>
          {[
            {
              ...lookingFor,
              value:
                lookingFor &&
                lookingFor.subquestions
                  .map(q => (q.value ? q.label : ''))
                  .filter(x => !!x)
                  .join(', '),
            },
            { ...year, value: year && year.min + ' - ' + year.max },
            { ...makemodel, value: makemodel && makemodel.subquestions.map(q => q.label).join(', ') },
          ].map((question, index) => {
            uniqueViewStr += question.label + question.value
            return (
              <div key={index}>
                <span>{question.label}:</span> {question.value}
              </div>
            )
          })}
        </Section>
      ) : (
        ''
      )}
    </>
  )
  calculateViewChange('replacementVehicle', loaded && uniqueViewStr)
  return component
}
